'use strict';

var React = require('react');

var SvgLiveViewMajor = function SvgLiveViewMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.523 6.28a5.25 5.25 0 0 0 0 7.425.75.75 0 1 1-1.06 1.06 6.75 6.75 0 0 1 0-9.545.75.75 0 0 1 1.06 1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.25 10a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0Zm2.75-1.25a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.462 13.705a5.25 5.25 0 0 0 0-7.425.75.75 0 1 1 1.061-1.06 6.75 6.75 0 0 1 0 9.546.75.75 0 0 1-1.06-1.061Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.79 8.048a2.75 2.75 0 0 0 0 3.89.75.75 0 1 1-1.06 1.06 4.25 4.25 0 0 1 0-6.01.75.75 0 1 1 1.06 1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.194 11.937a2.75 2.75 0 0 0 0-3.889.75.75 0 1 1 1.061-1.06 4.25 4.25 0 0 1 0 6.01.75.75 0 0 1-1.06-1.06Z"
  }));
};
SvgLiveViewMajor.displayName = "LiveViewMajor";

exports.SvgLiveViewMajor = SvgLiveViewMajor;
